import { PROPERTY_NAME, PROPERTY_VALUE, QUESTION_LIBRARY_STORE, SURVEY_EDITOR, TYPE_KEY } from "../common/constant";
import ObjectUtils, { coalesce } from "../utils/ObjectUtils";
import { beginLoading, endLoading } from "./loadingSpinner";
import { createBackendErrorMessages, createErrorMessages, createSuccessMessages, createWarningMessages, messagesReceived } from "./message";

import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import rest from "../common/rest";
import { cleanText } from "../utils/QuestionUtils";
import SurveyUtils from "../utils/SurveyUtils";
import { showDialog } from "./confirmDialog";
import { isQuestionKeyDuplicated } from "./surveyEditor";
import { changeQuestionField, importLibraryQuestions } from "./surveyEditorActions";

const CHANGE_PROPERTY_ACTION = "CHANGE_PROPERTY_ACTION";
const SORT_COLUMN_ACTION = "SORT_COLUMN_ACTION";
const SHOW_MODAL_FOR_LIBRARY_QUESTION_SETTINGS_ADD = "SHOW_MODAL_FOR_LIBRARY_QUESTION_SETTINGS_ADD";
const SHOW_MODAL_FOR_MY_LIBRARY_QUESTION_SETTINGS_ADD = "SHOW_MODAL_FOR_MY_LIBRARY_QUESTION_SETTINGS_ADD";
const SHOW_MODAL_FOR_LIBRARY_QUESTION_SETTINGS_EDIT = "SHOW_MODAL_FOR_LIBRARY_QUESTION_SETTINGS_EDIT";
export const SHOW_MODAL_QUESTION_LIBRARY_SETTINGS = "showModalQuestionLibrarySettings";
export const SHOW_MODAL_QUESTION_MY_LIBRARY_SETTINGS = "showModalQuestionMyLibrarySettings";
export const SHOW_MODAL_ADD_QUESTION_FROM_LIBRARY = "showModalAddQuestionFromLibrary";
export const SHOW_MODAL_ADD_QUESTION_FROM_OLD_LIBRARY = "showModalAddQuestionFromOldLibrary";
export const QUESTION_NAME = "questionName";
export const QUESTION_TITLE = "questionTitle";
export const QUESTION_ID = "questionId";
export const QUESTION_LIBRARY_ID = "libraryQuestionId";
export const QUESTION_ID_VALID = "questionIdValid";
export const QUESTION_ACTION_FIELD = "questionActionField";
export const QUESTION_RESULT = "questionResult";
export const PREVIEW_IMAGE_DATA = "previewImageData";
export const ACTION_FIELD = "actionField";
export const RESULT = "result";
export const QUESTION_TO_BE_ADDED = "questionToBeAdded";
export const QUESTION_SYNC = "questionSync";
export const SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY = "surveyLanguageForQuestionLibrary";
export const QUESTION_LIBRARY = "questionLibrary";
export const MY_QUESTION_LIBRARY = "myQuestionLibrary";
export const QUESTIONS_TO_ADD = "questionsToAdd";
export const QUESTION_TO_BE_EDITED = "questionToBeEdited";

export const SORT_TABLE_BY = "sortTableBy";
export const COL_SUBTYPE = "colSubtype";
export const SORT_LANGUAGE = "sortLanguage";
export const SORT_TABLE_ORDER = "sortTableOrder";

const initialState = {
  [SHOW_MODAL_QUESTION_LIBRARY_SETTINGS]: false,
  [SHOW_MODAL_ADD_QUESTION_FROM_LIBRARY]: false,
  [SHOW_MODAL_ADD_QUESTION_FROM_OLD_LIBRARY]: false,
  [QUESTION_NAME]: "",
  [QUESTION_ID]: "",
  [QUESTION_ID_VALID]: true,
  [QUESTION_ACTION_FIELD]: undefined,
  [QUESTION_RESULT]: undefined,
  [PREVIEW_IMAGE_DATA]: "",
  [ACTION_FIELD]: undefined,
  [RESULT]: undefined,
  [QUESTION_LIBRARY]: [],
  [MY_QUESTION_LIBRARY]: [],
  [QUESTIONS_TO_ADD]: [],
  [SORT_TABLE_ORDER]: true,
  [SORT_TABLE_BY]: "",
  [COL_SUBTYPE]: ""
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case CHANGE_PROPERTY_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    case SHOW_MODAL_FOR_LIBRARY_QUESTION_SETTINGS_ADD:
      newState = Object.assign({}, state, {
        [QUESTION_NAME]: action[QUESTION_NAME],
        [QUESTION_ID]: action[QUESTION_ID],
        [QUESTION_ID_VALID]: true,
        [QUESTION_SYNC]: action[QUESTION_SYNC],
        [QUESTION_ACTION_FIELD]: action[QUESTION_ACTION_FIELD],
        [QUESTION_RESULT]: action[QUESTION_RESULT],
        [PREVIEW_IMAGE_DATA]: action[PREVIEW_IMAGE_DATA],
        [QUESTION_TO_BE_ADDED]: action[QUESTION_TO_BE_ADDED],
        [SHOW_MODAL_QUESTION_LIBRARY_SETTINGS]: action[SHOW_MODAL_QUESTION_LIBRARY_SETTINGS],
        [SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY]: action[SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY]
      });
      break;
    case SHOW_MODAL_FOR_MY_LIBRARY_QUESTION_SETTINGS_ADD:
      newState = Object.assign({}, state, {
        [QUESTION_NAME]: action[QUESTION_NAME],
        [QUESTION_ID]: action[QUESTION_ID],
        [QUESTION_ID_VALID]: true,
        [PREVIEW_IMAGE_DATA]: action[PREVIEW_IMAGE_DATA],
        [QUESTION_TO_BE_ADDED]: action[QUESTION_TO_BE_ADDED],
        [SHOW_MODAL_QUESTION_MY_LIBRARY_SETTINGS]: action[SHOW_MODAL_QUESTION_MY_LIBRARY_SETTINGS],
        [SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY]: action[SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY]
      });
      break;
    case SHOW_MODAL_FOR_LIBRARY_QUESTION_SETTINGS_EDIT:
      newState = Object.assign({}, state, {
        [QUESTION_NAME]: action[QUESTION_NAME],
        [QUESTION_ID]: action[QUESTION_ID],
        [QUESTION_ID_VALID]: true,
        [QUESTION_ACTION_FIELD]: action[QUESTION_ACTION_FIELD],
        [QUESTION_RESULT]: action[QUESTION_RESULT],
        [PREVIEW_IMAGE_DATA]: action[PREVIEW_IMAGE_DATA],
        [QUESTION_TO_BE_EDITED]: action[QUESTION_TO_BE_EDITED],
        [SHOW_MODAL_QUESTION_LIBRARY_SETTINGS]: action[SHOW_MODAL_QUESTION_LIBRARY_SETTINGS],
        [SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY]: action[SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY],
      });
      break;
    case SORT_COLUMN_ACTION: {
      let sortedQuestions = SurveyUtils.handleSortQuestionLibrary(
        state[MY_QUESTION_LIBRARY],
        action[SORT_TABLE_BY],
        action[COL_SUBTYPE],
        action[SORT_TABLE_ORDER],
        action[SORT_LANGUAGE]
      );
      newState = Object.assign({}, state, {
        [MY_QUESTION_LIBRARY]: sortedQuestions,
        [SORT_TABLE_BY]: action[SORT_TABLE_BY],
        [SORT_TABLE_ORDER]: action[SORT_TABLE_ORDER],
        [COL_SUBTYPE]: action[COL_SUBTYPE]
      });
      break;
    }
    default:
      newState = Object.assign({}, state, {});
      break;
  }
  return newState;
}

export function changeProperty(propertyName, propertyValue) {
  return (dispatch, getState) => {
    dispatch({
      [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
      [PROPERTY_NAME]: propertyName,
      [PROPERTY_VALUE]: propertyValue
    });

    const libStore = getState()[QUESTION_LIBRARY_STORE];
    const editQuestion = libStore[QUESTION_TO_BE_EDITED];
    const addQuestion = libStore[QUESTION_TO_BE_ADDED];

    if (propertyName === QUESTION_ID && (editQuestion || addQuestion)) {
      const questions = libStore[QUESTION_LIBRARY];

      let existingQuestion;
      if (editQuestion) {
        existingQuestion = questions.find((q) => q.id !== editQuestion.id && q.questionId === propertyValue);
      } else {
        existingQuestion = questions.find((q) => q.questionId === propertyValue);
      }

      dispatch({
        [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
        [PROPERTY_NAME]: QUESTION_ID_VALID,
        [PROPERTY_VALUE]: existingQuestion === undefined
      });
    }
  };
}

export function showModalForSavingQuestionToLibrary(question, questionSync) {
  return (dispatch, getState) => {
    const { surveyLanguage } = getState().surveySettings;

    dispatch(getQuestionLibraryFromOverview()); // load all questions to store to validate questionId exists
    dispatch({
      [TYPE_KEY]: SHOW_MODAL_FOR_LIBRARY_QUESTION_SETTINGS_ADD,
      [QUESTION_NAME]: question.title,
      [QUESTION_TITLE]: question.title,
      [QUESTION_ID]: question[QUESTION_LIBRARY_ID],
      [QUESTION_ID_VALID]: true,
      [PREVIEW_IMAGE_DATA]: question.previewImageData,
      [ACTION_FIELD]: undefined,
      [RESULT]: undefined,
      [QUESTION_ACTION_FIELD]: undefined,
      [QUESTION_RESULT]: undefined,
      [QUESTION_TO_BE_ADDED]: question,
      [QUESTION_SYNC]: questionSync,
      [SHOW_MODAL_QUESTION_LIBRARY_SETTINGS]: true,
      [SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY]: surveyLanguage
    });
  };
}

export function showModalForSavingQuestionToMyLibrary(question) {
  return (dispatch, getState) => {
    const { surveyLanguage } = getState().surveySettings;
    dispatch(getQuestionLibraryFromOverview(true)); // load all questions to store to validate questionId exists
    dispatch({
      [TYPE_KEY]: SHOW_MODAL_FOR_MY_LIBRARY_QUESTION_SETTINGS_ADD,
      [QUESTION_NAME]: question.title,
      [QUESTION_TITLE]: question.title,
      [QUESTION_ID]: question[QUESTION_LIBRARY_ID],
      [QUESTION_ID_VALID]: true,
      [PREVIEW_IMAGE_DATA]: question.previewImageData,
      [ACTION_FIELD]: undefined,
      [RESULT]: undefined,
      [QUESTION_ACTION_FIELD]: undefined,
      [QUESTION_RESULT]: undefined,
      [QUESTION_TO_BE_ADDED]: question,
      [QUESTION_SYNC]: undefined,
      [SHOW_MODAL_QUESTION_MY_LIBRARY_SETTINGS]: true,
      [SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY]: surveyLanguage
    });
  };
}

export function showSettingsModalQuestionToLibrary(question) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: SHOW_MODAL_FOR_LIBRARY_QUESTION_SETTINGS_EDIT,
      [QUESTION_NAME]: question.name,
      [QUESTION_ID]: question[QUESTION_ID],
      [QUESTION_ID_VALID]: true,
      [QUESTION_ACTION_FIELD]: question.actionField,
      [QUESTION_RESULT]: question.result,
      [PREVIEW_IMAGE_DATA]: question.previewImageData,
      [QUESTION_TO_BE_EDITED]: question?.question,
      [SHOW_MODAL_QUESTION_LIBRARY_SETTINGS]: true,
      [SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY]: question.language,
    });
  };
}

/**
 *  Takes data from client which are needed for adding chosen question to library
 */
export function addQuestionToLibrary(questionSync, surveyName) {
  return (dispatch, getState) => {
    const questionLibraryStore = getState()[QUESTION_LIBRARY_STORE];
    const { questionName, questionId, questionToBeAdded, surveyLanguageForQuestionLibrary, previewImageData } =
      getState()[QUESTION_LIBRARY_STORE];
    const surveyEditorState = getState()[SURVEY_EDITOR];
    const { selectedPage } = surveyEditorState;
    questionToBeAdded.title = questionName;
    let question = {
      name: cleanText(questionName),
      title: questionName,
      questionId: questionId,
      draft: questionSync,
      privateQuestion: false,
      previewImageData: previewImageData,
      question: questionToBeAdded,
      language: surveyLanguageForQuestionLibrary,
      actionField: questionLibraryStore[QUESTION_ACTION_FIELD],
      result: questionLibraryStore[QUESTION_RESULT]
    };
    dispatch(beginLoading());
    rest.doPost(`/admin/library/questions/`, JSON.stringify(question)).then(
      (json) => {
        if (json) {
          dispatch(changeProperty(SHOW_MODAL_QUESTION_LIBRARY_SETTINGS, false));
          dispatch(changeProperty(ACTION_FIELD, undefined));
          dispatch(changeProperty(RESULT, undefined));
          dispatch(changeQuestionField(selectedPage, questionName, "libraryQuestionId", json.id));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 *  Takes data from client which are needed for adding chosen question to library
 */
export function addQuestionToMyLibrary(questionSync, surveyName, surveyIdentifier, surveyVersion) {
  return (dispatch, getState) => {
    const {
      questionName,
      questionId,
      questionToBeAdded,
      surveyLanguageForQuestionLibrary,
      previewImageData
    } = getState()[QUESTION_LIBRARY_STORE];

    const surveyEditorState = getState()[SURVEY_EDITOR];
    const { selectedPage } = surveyEditorState;
    questionToBeAdded.title = questionName;

    let question = {
      name: cleanText(questionName),
      title: questionName,
      questionId: questionId,
      draft: true,
      privateQuestion: true,
      previewImageData: previewImageData,
      question: questionToBeAdded,
      language: surveyLanguageForQuestionLibrary,
      surveyOrigin: surveyName,
      surveyOriginId: surveyIdentifier,
      surveyOriginVersion: surveyVersion
    };
    dispatch(beginLoading());
    rest.doPost(`/admin/library/questions/`, JSON.stringify(question)).then(
      (json) => {
        if (json) {
          dispatch(changeProperty(SHOW_MODAL_QUESTION_MY_LIBRARY_SETTINGS, false));
          dispatch(changeProperty(SHOW_MODAL_QUESTION_LIBRARY_SETTINGS, false));
          dispatch(changeQuestionField(selectedPage, questionName, "libraryQuestionId", json.id));
          dispatch(messagesReceived(createSuccessMessages("survey.editor.message.question_saved")));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 *  Takes data from client which are needed for editing chosen question from library
 */
export function editQuestionFromLibrary() {
  return (dispatch, getState) => {
    const questionLibraryStore = getState()[QUESTION_LIBRARY_STORE];
    const {
      questionName,
      questionId,
      questionToBeEdited,
      surveyLanguageForQuestionLibrary,
      previewImageData,
      questionActionField,
      questionResult
    } = questionLibraryStore;
    let question = {
      name: cleanText(questionName),
      questionId: questionId,
      previewImageData: previewImageData,
      question: questionToBeEdited,
      language: surveyLanguageForQuestionLibrary,
      actionField: questionActionField,
      result: questionResult
    };
    dispatch(beginLoading());
    rest.doPut(`/admin/library/questions/${questionId}`, JSON.stringify(question)).then(
      (json) => {
        if (json) {
          dispatch(changeProperty(SHOW_MODAL_QUESTION_LIBRARY_SETTINGS, false));
          dispatch(getQuestionLibraryFromOverview());
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 * creates url with parameters from question library overview
 */
export function getQuestionLibraryFromOverview(privateLibrary = false) {
  return (dispatch) => {
    dispatch(getQuestionLibrary(`/admin/library/questions/`, privateLibrary));
  };
}

/**
 * Gets questions library from server
 */
export function getQuestionLibrary(url, privateLibrary) {
  return (dispatch) => {
    let newUrl = url ? url : `/admin/library/questions/`;

    dispatch(beginLoading());
    !privateLibrary ? dispatch(changeProperty(QUESTION_LIBRARY, [])) : dispatch(changeProperty(MY_QUESTION_LIBRARY, []));
    rest.doGet(newUrl).then(
      (json) => {
        if (json) {
          if (!url) {
            !privateLibrary
              ? dispatch(changeProperty(SHOW_MODAL_ADD_QUESTION_FROM_LIBRARY, true))
              : dispatch(changeProperty(SHOW_MODAL_ADD_QUESTION_FROM_OLD_LIBRARY, true));
            dispatch(changeProperty(QUESTIONS_TO_ADD, []));
          }
          !privateLibrary ? dispatch(changeProperty(QUESTION_LIBRARY, json.questions)) : dispatch(changeProperty(MY_QUESTION_LIBRARY, json.questions));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 * Gets questions library from server
 */
export function getPrivateQuestionLibrary(urlWithFilters) {
  return (dispatch) => {
    dispatch(changeProperty(MY_QUESTION_LIBRARY, []));
    let url;
    if (!urlWithFilters) {
      url = `/admin/library/questions/privateQuestion/`;
    }

    let newUrl = urlWithFilters ? urlWithFilters : url;
    dispatch(beginLoading());
    rest.doGet(newUrl).then(
      (json) => {
        if (json) {
          if (!urlWithFilters) {
            dispatch(changeProperty(SHOW_MODAL_ADD_QUESTION_FROM_OLD_LIBRARY, true));
            dispatch(changeProperty(QUESTIONS_TO_ADD, []));
          }
          dispatch(changeProperty(MY_QUESTION_LIBRARY, json.questions));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

export function addQuestionToTemplate(question, add) {
  return (dispatch, getState) => {
    const questions = ObjectUtils.deepClone(coalesce(getState().questionLibrary.questionsToAdd, []));

    if (add) {
      questions.push(question);
      dispatch(changeProperty(QUESTIONS_TO_ADD, questions));
    } else {
      dispatch(changeProperty(QUESTIONS_TO_ADD, ObjectUtils.removeObjectByProp(questions, "id", question.id)));
    }
  };
}

export function submitAdding() {
  return (dispatch, getState) => {
    const libraryQuestions = getState().questionLibrary.questionsToAdd;
    const { selectedPage } = getState()[SURVEY_EDITOR];
    dispatch(importLibraryQuestions(selectedPage, libraryQuestions));
    const questionKeyDuplicated = libraryQuestions.some(({ question }) =>
      isQuestionKeyDuplicated(getState()[SURVEY_EDITOR], question.key)
    );
    dispatch(changeProperty(SHOW_MODAL_ADD_QUESTION_FROM_LIBRARY, false));
    dispatch(changeProperty(SHOW_MODAL_ADD_QUESTION_FROM_OLD_LIBRARY, false));

    if (questionKeyDuplicated) {
      dispatch(messagesReceived(createWarningMessages("template.activation.duplicate_key")));
    }
  };
}

export function removeQuestionFromLibraryConfirmed(question) {
  return (dispatch) => {
    dispatch(beginLoading());
    rest.doDelete(`/admin/library/questions/${question.id}`).then(
      (json) => {
        if (json) {
          dispatch(getPrivateQuestionLibrary());
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

export function handleRemoveQuestion(question) {
  return (dispatch) => {
    dispatch(
      showDialog(
        null,
        () => {
          dispatch(removeQuestionFromLibrary(question));
        },
        "survey.editor.confirm.question.deletion",
        "survey.editor.confirm.question.deletion",
        "confirmDialog.confirmLabel",
        "confirmDialog.dismissLabel",
        <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />
      )
    );
  }
}

/**
 *  Takes data from client which are needed for adding chosen question to library
 */
export function removeQuestionFromLibrary(question) {
  return (dispatch) => {
    // check whether indicators are referencing this question
    rest
      .doGet(`/admin/indicators/search/countByLibraryQuestion?libraryQuestionId=${question.id}`)
      .then((referenceCount) => {
        if (referenceCount === 0) {
          // check whether survey templates uses this question
          rest
            .doGet(`/admin/admin/surveys/search/countByContainedLibraryQuestion?libraryQuestionId=${question.id}`)
            .then((referenceCount) => {
              if (referenceCount === 0) {
                dispatch(removeQuestionFromLibraryConfirmed(question));
              } else {
                dispatch(
                  showDialog(
                    {},
                    () => {
                      dispatch(removeQuestionFromLibraryConfirmed(question));
                    },
                    "question.library.deletion.confirm.referencing.templates.title",
                    "question.library.deletion.confirm.referencing.templates.message",
                    "confirmDialog.ok",
                    "confirmDialog.cancel"
                  )
                );
              }
            });
        } else {
          dispatch(
            showDialog(
              {},
              () => {},
              "question.library.deletion.not.possible.dialog.title",
              "question.library.deletion.not.possible.dialog.message",
              "confirmDialog.ok",
              null
            )
          );
        }
      });
  };
}

export const sortColumn = (columnType, subtype, acs, language) => {
  return {
    [TYPE_KEY]: SORT_COLUMN_ACTION,
    [SORT_TABLE_BY]: columnType,
    [COL_SUBTYPE]: subtype,
    [SORT_TABLE_ORDER]: acs,
    [SORT_LANGUAGE]: language
  };
};
